export default {
    setBookingForm (state, data) {
        state.bookingForm = data
    },
    setBooking (state, booking) {
        state.booking = booking
    },
    setBookingChangelog (state, booking) {
        state.bookingChangelog = booking
    },
    setIsReturnBooking (state, bool) {
        state.isReturnBooking = bool
    },
    setReloadBooking (state, bool) {
        state.reloadBooking = bool
    },
    setBookingRepeatServiceId (state, bool) {
        state.bookingRepeatServiceId = bool
    }
}
